var $e33d3b3868478b04$exports = {};
$e33d3b3868478b04$exports = {
    "close": `\xcenchide\u{163}i`,
    "notifications": `Notific\u{103}ri`
};


export {$e33d3b3868478b04$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
